import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import React, { useCallback } from 'react'

import { CallerMatch } from './screenPopApi'

interface CallerMatchItemProps {
  match: CallerMatch
  isSelected: boolean
  onOpen: (accountId: string) => void
}

const CallerMatchItem = ({ match, isSelected, onOpen }: CallerMatchItemProps) => {
  const label = match.accountNumber ? `${match.accountName} #${match.accountNumber}` : match.accountName

  const handleClick = useCallback(() => onOpen(match.accountId), [match.accountId, onOpen])

  return (
    <ListItemButton selected={isSelected} onClick={handleClick}>
      <ListItemText primary={label} secondary={match.serviceAddress} />
    </ListItemButton>
  )
}

export default CallerMatchItem
